<mat-toolbar class="tool-bkg">
  <!-- In .sidebar-header -->
  <!-- <button type="button" class="sidebar-aux" (click)="toggleCollapse()">
    <mat-icon>{{ collapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    <span *ngIf="!collapsed">Collapse</span>
  </button> -->

  <button class="menu-button" mat-icon-button aria-label="Example icon-button with menu icon"
    (click)="onToggleSidenav()">
    <mat-icon class="nav-icon">menu</mat-icon>
  </button>
  <img src="/assets/images/CW_Logo_Color.jpg" alt="Cushman & Wakefield Logo" class="toolbar-logo" />

  <span class="example-spacer"></span>

  <ng-container *ngIf="loginDisplay">
    <div class="user-info">
      <span class="username">{{ this.userData.displayName }}</span>
      <span class="user-role">{{ this.userData.currentRole }}</span>
    </div>
    <button mat-icon-button aria-label="User menu">
      <mat-icon class="nav-icon">account_circle</mat-icon>
    </button>
  </ng-container>

  <mat-menu #appMenu="matMenu">
    <button mat-menu-item>
      <mat-icon>settings</mat-icon>
      <span>Settings</span>
    </button>
    <button mat-menu-item>
      <mat-icon>help</mat-icon>
      <span>Help</span>
    </button>
  </mat-menu>
</mat-toolbar>